// O modelo AUTORAL da cruzada direta — a fonte da verdade do editor.
//
// É plano, imutável e serializável em JSON (contrato do shell: history, dirty
// tracking e autosave saem disso de graça). Mapeia 1:1 no `CrosswordDraftDto` do
// backend; o `wire.ts` faz a conversão. O cliente não conhece ids: cada palavra tem
// um `ref` temporário e a casa morta aponta para refs — o servidor materializa os ids.
//
// A grade NÃO é armazenada: é projetada em leitura a partir de `words` + `deadCells`
// (ver `project.ts`), espelhando o `gera_matrix` do servidor. O autor edita o modelo,
// não a matriz.

/** Palavra pendurada numa casa morta. Seu tamanho É `texto.length` (não há slot
 *  pré-cavado na direta): as letras ocupam `x..x+len-1` (horizontal) ou `y..y+len-1`. */
export interface WordDraft {
  ref: string; // id temporário; /^[A-Za-z0-9_-]{1,32}$/ (contrato do DTO)
  texto: string; // normalizado (MAIÚSCULA, sem acento) ao digitar
  x: number; // casa inicial
  y: number;
  direcao: boolean; // false = horizontal, true = vertical
  chave: string; // a dica (vira chaves[ordem=0])
}

/** Casa de dica: segura as dicas (por slot) e é dela que sai a numeração. */
export interface DeadCell {
  x: number;
  y: number;
  visivel: boolean;
  palavra1Ref: string | null; // slot 1
  palavra2Ref: string | null; // slot 2
}

export interface Highlight {
  x: number;
  y: number;
}

export interface CrosswordDoc {
  titulo: string;
  largura: number;
  altura: number;
  tiposDePassatemposId: number | null;
  words: WordDraft[];
  deadCells: DeadCell[];
  highlights: Highlight[];
}

export interface CreateEmptyParams {
  titulo: string;
  largura: number;
  altura: number;
  tiposDePassatemposId: number | null;
}

/** Documento vazio de dimensões dadas — o par de `load()` no fluxo de criação.
 *  Nasce sem palavras nem casas mortas; o `validate` cobra as mínimas antes do save. */
export function createEmpty(params: CreateEmptyParams): CrosswordDoc {
  return {
    titulo: params.titulo,
    largura: params.largura,
    altura: params.altura,
    tiposDePassatemposId: params.tiposDePassatemposId,
    words: [],
    deadCells: [],
    highlights: [],
  };
}
